import { render, staticRenderFns } from "./GeneralDialogAcompanhamento.vue?vue&type=template&id=805e1a5e&"
import script from "./GeneralDialogAcompanhamento.vue?vue&type=script&lang=js&"
export * from "./GeneralDialogAcompanhamento.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDialogAcompanhamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog})
